import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SharedContentModel } from 'src/app/Modules/settings/models/general/shared-content-model';
import { ManagementApiService } from 'src/app/services';
import { SharedContentCategory } from 'src/app/Modules/settings/enums/shared-content-category.enum';
import { TranslocoService } from '@jsverse/transloco';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { EnvironmentService } from 'src/app/services/environment.service';
@Component({
    selector: 'app-pricing-details-data',
    templateUrl: './pricing-details-data.component.html',
    styleUrls: ['./pricing-details-data.component.scss'],
    standalone: false,
})
export class PricingDetailsDataComponent implements OnInit, OnDestroy {
    _destroying$: Subject<any> = new Subject();
    sharedContentsList: SharedContentModel[] = null;
    hideDeleteOption: boolean;
    hideEditOption: boolean;
    sharedContentsListCopy: SharedContentModel[];
    language: any;

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private translocoService: TranslocoService,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private msalService: MsalService,
        private router: Router,
        private EnvironmentService: EnvironmentService
    ) {}

    ngOnInit(): void {
        this.getSharedContents();
    }

    getSharedContents() {
        let language = 'en';
        if (this.msalService.instance.getActiveAccount()) {
            language = this.translocoService.getActiveLang();
            //Check for the browser language with the trans loc service's active language, if its not matching, then get the browser language
            if (language != navigator.language.split('-')[0]) language = navigator.language.split('-')[0];
        } else {
            if (this.translocoService.getAvailableLangs().some((language) => language == navigator.language.split('-')[0])) {
                language = navigator.language.split('-')[0];
            }
        }
        this.sharedContentsList = [];
        this.ngxUiLoaderService.start();
        this.mgmtApi
            .getSharedContentForLandingPage(SharedContentCategory.Pricing, language)
            .pipe(takeUntil(this._destroying$))
            .subscribe(
                (sharedContents) => {
                    this.ngxUiLoaderService.stop();
                    this.sharedContentsList = [];
                    if (sharedContents.success == true) {
                        this.sharedContentsList = sharedContents.response;

                        if (this.msalService.instance.getActiveAccount()) {
                            this.sharedContentsList = this.sharedContentsList.filter((x) => x.isPurchase == true);
                        }
                        this.cd.markForCheck();
                    } else {
                        this.user_utility.errorModelPopup(sharedContents.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                }
            );
    }

    async openSignUpFlow() {
        let signUpFlowRequest = {
            scopes: environment.scopes,
            authority: environment.b2cPolicies.authorities.signUp.authority,
        };

        await this.msalService.instance.handleRedirectPromise();
        this.signUp(signUpFlowRequest);
    }

    async signUp(userFlowRequest?: RedirectRequest | PopupRequest) {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            if (this.msalGuardConfig.authRequest) {
                await this.msalService.instance.handleRedirectPromise();
                this.msalService
                    .loginPopup({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as PopupRequest)
                    .pipe(takeUntil(this._destroying$))
                    .subscribe((response: AuthenticationResult) => {
                        this.msalService.instance.setActiveAccount(response.account);
                        this.router.navigate(['/home']);
                    });
            }
        }
    }

    ngOnDestroy(): void {
        this._destroying$.next(null);
        this._destroying$.unsubscribe();
    }
}
